import { TZDate } from '@date-fns/tz';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';
import { CustomDateFormats, noddiFormatDate } from 'noddi-util';

type LatestDeliveryDialogProps = {
  open: boolean;
  onClose: () => void;
  latestAvailableDate: TZDate;
  translations: {
    latestDeliveryDialogTitle: string;
    latestDeliveryDialogMessage: string;
    latestAvailableDate: string;
    latestDeliveryExplanation: string;
  };
};

export const LatestDeliveryDialog = ({
  open,
  onClose,
  latestAvailableDate,
  translations
}: LatestDeliveryDialogProps) => {
  const formattedDate = noddiFormatDate(latestAvailableDate, CustomDateFormats.FULL_DAY_MONTH);

  return (
    <NoddiDialog
      title={translations.latestDeliveryDialogTitle}
      onClose={onClose}
      open={open}
      footer={
        <NoddiButton onClick={onClose} variant='primary' className='w-full'>
          OK
        </NoddiButton>
      }
    >
      <div className='flex flex-col gap-4'>
        <p>{translations.latestDeliveryDialogMessage}</p>
        <div className='rounded-lg border p-4'>
          <p className='text-sm font-semibold'>{translations.latestAvailableDate}</p>
          <p className='text-lg font-semibold'>{formattedDate}</p>
        </div>
        <p className='text-sm text-gray-600'>{translations.latestDeliveryExplanation}</p>
      </div>
    </NoddiDialog>
  );
};
